import { aboutValues } from "@/mocks/site/content";

export default function ValuesSection() {
  return (
    <section className="py-20 md:py-28 bg-[#FAF5EC]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mb-12">
          <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
            What we stand for
          </div>
          <h4 className="font-display text-3xl md:text-5xl font-bold text-ink-900 leading-tight tracking-tight">
            <a href="#values" className="text-ink-900 hover:text-ink-900 no-underline">
              Three things we won't compromise on.
            </a>
          </h4>
        </div>

        <div id="values" className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {aboutValues.map((v, i) => (
            <article
              key={v.title}
              className="relative bg-white rounded-2xl p-7 md:p-8 border border-ink-100 hover:border-brand-300 transition-colors"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-brand-100 text-brand-600">
                  <i className={`${v.icon} text-2xl`}></i>
                </div>
                <span className="font-display text-3xl font-bold text-ink-200">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display text-xl md:text-2xl font-bold text-ink-900 leading-tight mb-3">
                {v.title}
              </h3>
              <p className="text-sm text-ink-600 leading-relaxed">{v.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}